import { Validators } from '@angular/forms'
import { ForceAny } from '@shared/types'


export const componentCentreFleetApiEndpoints: Record<string, string> = {
  AIRCRAFT: 'aircraft',
  ENGINE: 'engine',
  LANDING_GEAR: 'landing-gear',
  LANDING_GEAR_MODULE: 'landing-gear',
  APU: 'apu',
  THRUST_REVERSER: 'thrust/fleet-status',
  PROPELLER: 'propeller',
}

export type KeyOfCentreFleets = keyof typeof componentCentreFleetApiEndpoints

export const COMPONENT_TO_LAB_MAP: Record<string, string> = {
  AIRCRAFT: 'Aircraft',
  LANDING_GEAR: 'Landing Gear',
  ENGINE: 'Engine',
  APU: 'APU',
  THRUST_REVERSER: 'Thrust Reverser',
  PROPELLER: 'Propeller',
}

export const CENTRE_LIST_MCC_ASSET = {
  AIRCRAFT_CENTRE: 'Aircraft Centre',
  ENGINE_CENTRE: 'Engine Centre',
  LANDING_GEAR_CENTRE: 'Landing Gear Centre',
  APU_CENTRE: 'APU Centre',
  GENERAL_COMPONENT: 'General Components',
}

export enum FLEET_VIEW_TYPES {
  AIRCRAFT = 'AIRCRAFT',
  ENGINE = 'ENGINE',
  ENGINE_OFF_WING = 'ENGINE_OFF_WING',
  ENGINE_MODULE = 'ENGINE_MODULE',
  ENGINE_STAND = 'ENGINE_STAND',
  LANDING_GEAR = 'LANDING_GEAR',
  LANDING_GEAR_SUB_ASSEMBLY = 'LANDING_GEAR_SUB_ASSEMBLY',
  LANDING_GEAR_ON_GROUND = 'LANDING_GEAR_ON_GROUND',
  APU = 'APU',
  APU_NOT_INSTALLED = 'APU_NOT_INSTALLED',
  THRUST_REVERSER = 'THRUST_REVERSER',
  THRUST_REVERSER_NOT_INSTALLED = 'THRUST_REVERSER_NOT_INSTALLED',
  PROPELLER = 'PROPELLER',
  PROPELLER_OFF_WING = 'PROPELLER_OFF_WING',
}

export enum MR_VIEW_TYPES {
  AIRCRAFT = 'AIRCRAFT',
  ENGINE = 'ENGINE',
}

export enum FLEET_SECTION_ENUM {
  FLEET_STATUS = 'FLEET_STATUS',
  OFF_WING = 'OFF_WING',
  MODULE_FLEET = 'MODULE_FLEET',
  ON_GROUND = 'ON_GROUND',
}

export const fleetStatusToSectionMapping: Partial<Record<ForceAny, FLEET_SECTION_ENUM>> = {
  AIRCRAFT_FLEET: FLEET_SECTION_ENUM.FLEET_STATUS,
  ENGINE_FLEET: FLEET_SECTION_ENUM.FLEET_STATUS,
  PROPELLER_FLEET: FLEET_SECTION_ENUM.FLEET_STATUS,
  APU_FLEET: FLEET_SECTION_ENUM.FLEET_STATUS,
  LANDING_GEAR_FLEET: FLEET_SECTION_ENUM.FLEET_STATUS,
  ENGINE_MODULE_FLEET: FLEET_SECTION_ENUM.MODULE_FLEET,
}



export const copyMoveCCBoxFolderControls = {
  name: [''],
  clientId: ['', [Validators.required]],
  folderId: ['', [Validators.required]],
  title: ['', [Validators.required]],
  fromMonthYear: [''],
  toMonthYear: [''],
  keywordSearch: [''],
  options: [''],
}


export const copyMoveBoxFolderErrorMessages = {
  viewType: 'Please select view type.',
  clientId: 'Please select client.',
  centreType: 'Please select centre.',
  component: 'Please select component.',
  folderId: 'Please select folder to copy.',
}

export const componentCentre = {
  viewType: 'COMPONENT_CENTRE',
  section: 'COMPONENT',
}

export const UTILISATION_SECTION = {
  viewType: 'UTILISATION',
  section: 'UTILISATION',
}

/**
 * @description Can be used in any mapping of centre type to its default component
 * If there is no mapping of centre to its component then map the key to itself like GENERAL_COMPONENT
 * @NOTE ==> Please donot alter existing key-value pairs !!!
 */
export const COMMON_CENTRE_TYPE_TO_COMPONENT_MAP: Record<string, string> = {
  ...FLEET_VIEW_TYPES,
  AIRCRAFT_CENTRE: 'AIRCRAFT',
  ENGINE_CENTRE: 'ENGINE',
  LANDING_GEAR_CENTRE: 'LANDING_GEAR',
  APU_CENTRE: 'APU',
  PROPELLER_CENTRE: 'PROPELLER',
  THRUST_REVERSER_CENTRE: 'THRUST_REVERSER',
  GENERAL_COMPONENT: 'GENERAL_COMPONENT',
  COMPONENT_CENTRE: 'COMPONENT_CENTRE',
  INTERNAL: 'INTERNAL',
  MMD: 'MMD',
}

export const COMPOENT_CENTRE_TO_TYPE_MAPPING: Record<string, string> = {
  AIRCRAFT: 'AIRCRAFT_CENTRE',
  ENGINE: 'ENGINE_CENTRE',
  ENGINE_MODULE: 'ENGINE_MODULE',
  LANDING_GEAR: 'LANDING_GEAR_CENTRE',
  LANDING_GEAR_MODULE: 'LANDING_GEAR_MODULE',
  APU: 'APU_CENTRE',
  THRUST_REVERSER: 'THRUST_REVERSER_CENTRE',
  PROPELLER: 'PROPELLER_CENTRE',
  GENERAL_COMPONENT: 'GENERAL_COMPONENT',
  ENGINE_STAND: 'ENGINE_STAND_CENTRE',
}

export const COMPONENT_TO_TYPE_KEY_MAP: Record<string , string> = {
  AIRCRAFT: 'typeId',
  ENGINE: 'engineType',
  ENGINE_MODULE: 'engineType',
  LANDING_GEAR: 'landingGearType',
  LANDING_GEAR_MODULE: 'landingGearType',
  APU: 'apuType',
  THRUST_REVERSER: 'thrustReverserType',
  PROPELLER: 'propellerType',
  ENGINE_STAND: 'engineType',
}

export const MCC_THIRD_PARTY_PERMISSION_VAL: Record<keyof typeof COMPOENT_CENTRE_TO_TYPE_MAPPING, number> = {
  [COMPOENT_CENTRE_TO_TYPE_MAPPING['AIRCRAFT']]: -1,
  [COMPOENT_CENTRE_TO_TYPE_MAPPING['ENGINE']]: -2,
  [COMPOENT_CENTRE_TO_TYPE_MAPPING['LANDING_GEAR']]: -4,
  [COMPOENT_CENTRE_TO_TYPE_MAPPING['APU']]: -3,
  [COMPOENT_CENTRE_TO_TYPE_MAPPING['GENERAL_COMPONENT']]: 1117,
}
